<template>
  <form novalidate class="full-width ro-claim-editor" @submit.prevent="saveClaim()">
    <div class="row items-baseline apportion-row justify-between r-p-side">
      <div class="col-auto">
        <div class="event-icon-wrapper flex flex-center">
          <q-icon
            :name="event.attributes( ).icon"
            class="event-icon self-center"
            :class="event.event_type.toLowerCase()"
          />
        </div>
      </div>
      <div class="col-auto">
        <div class="row items-baseline border-bottom">
          <div class="col-auto">
            <div class="forc-selector">{{ claim.forc.text }}<q-tooltip>{{ claim.forc.description }}</q-tooltip></div>
          </div>

          <div class="col-auto text-right">
            <div class="apportion">{{ claim.apportion }}%</div>
          </div>
        </div>
      </div>

      <div class="col-auto">
        <q-checkbox v-model="claim.is_peer_reviewed" disable>
          Peer review
        </q-checkbox>
      </div>
    </div>
    <div class="full-width r-p-all">
      <div class="full-width user-and-time">
        <span v-if="event.actingUserDisplayName()">
          {{ event.actingUserDisplayName() }} at
        </span>
        {{ formatDateTime(event.updated_at) }}
        <span class="float-right">
          {{ event.userFriendlyActionName() }}
        </span>
      </div>
      <div class="full-width r-p-top">
        <q-input
          name="comment"
          type="textarea"
          hide-underline
          class="border border-black comfortable-textarea"
          size="xl"
          readonly
          :max-height="48"
          :value="claim.comment"
        />
      </div>
    </div>
  </form>
</template>

<script>
import { formatDateTime } from '@/utils/date';
import ResearchOutputClaimEvent from '@/models/research-output/research-output-claim-event';

export default {
  name: 'ClaimUpdateEvent',
  props: {
    event: {
      type: ResearchOutputClaimEvent,
      required: true,
    },
  },
  computed: {
    claim() {
      return this.event.getFirstClaim();
    },
  },
  methods: {
    formatDateTime,
  },
};
</script>
<style lang="stylus" scoped>
  .apportion-row
    background-color $mq-sand
    padding-top 20.5px
    padding-bottom 20.5px

  .comment-row
    padding-top $radar-general-padding

  .forc-selector
    min-width 140px
    font-size 16px

  .apportion
    min-width 83px
    font-size 16px

  .event-icon-wrapper
    height 58px
    width 58px
    border 1px solid
    border-radius 50%
    background-color $mq-soft

  .event-icon
    font-size 24px

  .add_claim, .update_claim, .remove_claim, .claim_synced_from_previous_era, .added_from_bulk
    font-size 28px
    color white
</style>
